import { PaginationInfo } from "@thrivecoin/adapter/dist/types";

type PaginationParam = {
  pagination: PaginationInfo;
};

export const getNextPageParam = ({ pagination }: PaginationParam) => {
  if (!pagination) return;

  const { Total, Page, "Per-Page": perPage } = pagination;
  return Page && perPage && Total > Page * perPage ? Page + 1 : undefined;
};
